import { Deck } from '../../model/domain/Deck';
import { DecksTO } from '../to/DeckTO';

const toDomain = (to: DecksTO): Deck[] =>
  to.map((deck) => ({
    deckId: deck.deckId,
    deckName: deck.deckName,
    tkl: deck.tkl,
  }));

export default {
  toDomain,
};
